module.exports = __webpack_public_path__ + "img/pbms-desktop.39cea4bb.webp";